<template>
  <div class="app-root">
    <nuxt-route-announcer />

    <core-provider>
      <layout-provider>
        <nuxt-layout fallback="default">
          <nuxt-page />
        </nuxt-layout>
      </layout-provider>
    </core-provider>

    <core-scope />
  </div>
</template>

<script setup lang="ts">

</script>
